import styled from 'foundations-theming/utils';
import I18n from 'I18n';
import { useSelector } from 'react-redux';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { FieldVisibilityControlsWrapper } from './FieldVisibilityControls';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getForwardCommunicatorState } from 'composer-data/email/public/selectors';
// @ts-expect-error module not typed
import { getInReplyToId } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getCommonMessage } from 'conversations-thread-data/common-reply/public/operators/commonReplyGetters';
import { getRecipientsIconName } from '../operators/getRecipientsIconName';
import MetadataInputLabel from './MetadataInputLabel';
import EmailTagDisplayBar from './EmailTagDisplayBar';
import { RecipientTagDisplayBar } from './RecipientTagDisplayBar';
import { RecipientTooltipTitle } from './RecipientTooltipTitle';
import { VerticalMenuIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CollapsedInputWrapper = styled.label.withConfig({
  displayName: "CollapsedMetadataEditor__CollapsedInputWrapper",
  componentId: "sc-5f36jj-0"
})(["display:inline-flex;flex-grow:1;width:90%;color:", ";"], ({
  theme
}) => theme.color['text-core-default']);
export const CollapsedMetadataEditor = ({
  allRecipients,
  handleMoreButtonOnClick,
  handleSetExpanded,
  reply,
  toLabel,
  onChange,
  showSenderSubjectFields,
  useWhatsAppCompose
}) => {
  const MAX_RECIPIENTS_TO_SHOW_IN_COLLAPSED_METADATA = 2;
  const {
    replyAll
  } = useSelector(getForwardCommunicatorState);
  const commonMessageReply = getCommonMessage(reply);
  const inReplyToId = getInReplyToId(commonMessageReply);
  const iconName = getRecipientsIconName({
    allRecipients,
    commonMessageReply,
    replyAll
  });
  const verticalMenuTooltip = showSenderSubjectFields ? I18n.text('composer-ui.metadata-editor.collapsed-metadata-editor.hide-sender-and-subject') : I18n.text('composer-ui.metadata-editor.collapsed-metadata-editor.edit-sender-and-subject');
  const buttonTestId = showSenderSubjectFields ? 'metadata-expand-button-collapse' : 'metadata-expand-button-expand';
  const fieldVisibilityControls = /*#__PURE__*/_jsx(FieldVisibilityControlsWrapper, {
    children: /*#__PURE__*/_jsx(IconButton, {
      onClick: handleMoreButtonOnClick,
      placement: "top",
      tooltip: verticalMenuTooltip,
      use: "link",
      "data-selenium-test": buttonTestId,
      children: /*#__PURE__*/_jsx(IconHolder, {
        marginInlineEnd: "0",
        icon: VerticalMenuIcon,
        size: "200",
        color: "icon-core-subtle"
      })
    })
  });
  const DisplayBarComponent = useWhatsAppCompose ? /*#__PURE__*/_jsx(RecipientTagDisplayBar, {
    allRecipients: allRecipients,
    multiCollapseLimit: MAX_RECIPIENTS_TO_SHOW_IN_COLLAPSED_METADATA,
    onClick: handleSetExpanded,
    onChange: onChange,
    reply: reply
  }) : /*#__PURE__*/_jsx(EmailTagDisplayBar, {
    clearableValues: false,
    allRecipients: allRecipients,
    multiCollapseLimit: MAX_RECIPIENTS_TO_SHOW_IN_COLLAPSED_METADATA,
    onClick: handleSetExpanded,
    onChange: onChange,
    commonMessageReply: commonMessageReply
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [inReplyToId && iconName ?
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs(CollapsedInputWrapper, {
      "data-selenium-test": "metadata-to-input",
      children: [/*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(RecipientTooltipTitle, {
          iconName: iconName.name
        }),
        placement: "bottom",
        children: /*#__PURE__*/_jsx(IconHolder, {
          "data-selenium-test": "metadata-to-icon",
          icon: iconName.icon,
          display: "inline-flex",
          alignItems: "center",
          padding: "0",
          marginInlineEnd: "200",
          size: "600"
        })
      }), DisplayBarComponent]
    }) : /*#__PURE__*/_jsx(MetadataInputLabel, {
      label: toLabel,
      "data-selenium-test": "metadata-to-input",
      children: DisplayBarComponent
    }), fieldVisibilityControls]
  });
};
CollapsedMetadataEditor.displayName = 'CollapsedMetadataEditor';